<div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">

  <!-- Título -->
  <div>
    <h2 class="mb-3 mb-md-0">{{ title }}</h2>
  </div>

  <!-- Botones derecha -->
  <div class="d-flex align-items-center gap-3">

    <!-- Botón Nueva Orden (solo cuando se active) -->
    <div *ngIf="showNewOrderButton"
         class="badge rounded-pill bg-primary"
         style="cursor: pointer; padding: 10px 14px;"
         [routerLink]="'/orders/new-order'"
         placement="top"
         ngbTooltip="{{'ORDER_LIST.tooltipNewOrder' | translate }}">
      <i class="feather icon-plus me-1"></i>
      {{'ORDER_LIST.tooltipNewOrder' | translate }}
    </div>

    <!-- Botón Back -->
    <span class="cursor-pointer fs-4" (click)="goBack()">
      <i class="feather icon-arrow-left btn-icon-prepend"></i>
      {{'BREADCRUMB.back' | translate }}
    </span>

  </div>

</div>